import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getUserMenuList } from "../../../application/selectors/user";

const normalizePath = (pathname) =>
  String(pathname || "")
    .replace(/\/+$/, "")
    .toLowerCase();

const findPageByPath = (items, pathname) => {
  if (!Array.isArray(items)) return null;

  const target = normalizePath(pathname);

  for (const menu of items) {
    const link = normalizePath(menu?.link);
    if (link && link === target) {
      return menu;
    }

    const found = findPageByPath(menu?.child, pathname);
    if (found) {
      return found;
    }
  }

  return null;
};

const useGetPageInfo = () => {
  const { pathname } = useLocation();
  const menuList = useSelector(getUserMenuList);
  const [pageInfo, setPageInfo] = useState({});

  useEffect(() => {
    if (!Array.isArray(menuList) || menuList.length === 0) {
      setPageInfo({});
      return;
    }

    setPageInfo(findPageByPath(menuList, pathname) || {});
  }, [menuList, pathname]);

  return pageInfo;
};

export default useGetPageInfo;
